import React from "react";
import {EllipsisVerticalIcon} from "@heroicons/react/24/solid";
import {
    Menubar,
    MenubarContent,
    MenubarItem,
    MenubarMenu,
    MenubarSeparator,
    MenubarTrigger
} from "../../shadCn/components/ui/MenuBar";
import AlertModal from "../basic/AlertModal";

export function DropdownMenu({handleCreateChild, handleUpdate, handleDelete, title, className}) {

    return (
        <>
            <Menubar className={`${className}`}>
                <MenubarMenu className={"menubar-menu"}>
                    <MenubarTrigger className={"cursor-pointer"}>
                        <EllipsisVerticalIcon className={"w-5"}/>
                    </MenubarTrigger>
                    <MenubarContent>
                        {handleCreateChild && (<>
                            <MenubarItem className={"cursor-pointer"} onClick={handleCreateChild}>
                                하위등록
                            </MenubarItem>
                            <MenubarSeparator/>
                            </>
                        )}
                        {handleUpdate && (
                            <>
                                <MenubarItem className={"cursor-pointer"} onClick={handleUpdate}>
                                    수정
                                </MenubarItem>
                                <MenubarSeparator/>
                            </>
                        )}
                        {handleDelete && (
                            <>
                                <div className={"m-2"}>
                                    {title &&
                                        <>
                                            {title === "code" &&
                                                <AlertModal
                                                    triggerName={"삭제"} handler={handleDelete}
                                                    triggerClassName={"w-full text-start text-sm"} actionName={"삭제하기"}
                                                    title={"선택한 코드를 삭제하시겠습니까?"}
                                                    description={"선택한 코드의 하위코드가 있으면 삭제할 수 없습니다."}
                                                />}
                                            {title === "department" &&
                                                <AlertModal
                                                    triggerName={"삭제"} handler={handleDelete}
                                                    triggerClassName={"w-full text-start text-sm"} actionName={"삭제하기"}
                                                    title={"선택한 부서를 삭제하시겠습니까?"}
                                                    description={"하위부서가 있으면 삭제할 수 없습니다."}
                                                />}
                                        </>
                                    }
                                    {!title && (
                                        <AlertModal
                                            triggerName={"삭제"} handler={handleDelete}
                                            triggerClassName={"w-full text-start text-sm"} actionName={"삭제하기"}
                                            title={"삭제하시겠습니까?"}
                                        />
                                    )}
                                </div>
                            </>
                        )}

                    </MenubarContent>
                </MenubarMenu>
            </Menubar>
        </>
    )
}

